import React, { useRef, useState } from 'react';
import { useOnClickOutside } from '../../../hooks';
import { Button } from '../../Button';
import { ScrollableViewport } from '../../ScrollableViewport';
import { dropdownButtonCss } from '../utils';
import './DropdownButton.scss';
export const DropdownButton = ({ className, overrideCss, buttonText, buttonIcon, options = [], onChange = () => { }, onButtonClick = () => { }, truncateLongValues, disabled, }) => {
    const { dropdownBlock, dropdownButtonArea, dropdownButtonWrapper, dropdownDivider, dropdownListArea, dropdownListItem, dropdownArrowArea, dropdownArrow, } = dropdownButtonCss({
        className,
        overrideCss,
        truncateLongValues,
        disabled,
    });
    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    useOnClickOutside(ref, () => {
        setIsOpen(false);
    });
    const handleClick = (option) => {
        if (!disabled) {
            if (onChange) {
                onChange(option);
            }
            setIsOpen(false);
        }
    };
    const handleOpen = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };
    return (React.createElement("div", { ref: ref, className: dropdownBlock },
        React.createElement("div", { className: dropdownButtonArea },
            React.createElement("div", { className: dropdownButtonWrapper },
                React.createElement(Button, { className: className, overrideCss: overrideCss, text: buttonText, iconSrc: buttonIcon, theme: "transparent", onClick: onButtonClick, disabled: disabled })),
            React.createElement("div", { className: dropdownDivider }),
            React.createElement("button", { type: "button", onClick: handleOpen, className: dropdownArrowArea },
                React.createElement("div", { className: dropdownArrow }))),
        isOpen ? (React.createElement("div", { className: dropdownListArea },
            React.createElement(ScrollableViewport, { vertical: true }, options.map((item) => (React.createElement("button", { className: dropdownListItem, type: "button", onClick: () => handleClick(item.value) }, item.displayText)))))) : null));
};
//# sourceMappingURL=DropdownButton.js.map